export default __webpack_public_path__ + "static/media/amd_ryzen_7_logo.86fc2e29.svg";